import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import TopMenu from "../layouts/TopMenu";
import Dashboard from "../views/Dashboard";
import Evolution from "../views/Evolution";
import Login from "../views/Login";
import ErrorPage from "../views/ErrorPage";
import Maintanence from '../views/Maintanence';
import New_Evolution from '../views/New_Evolution'
import SA_Gaming from '../views/Sa_Gaming'

Vue.use(VueRouter);
 
const routes = [
  {
    path: "/",
    component: TopMenu,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "home",
        component: Dashboard,
        meta: {title: 'LiveGame - Home'}
      },
      {
        path: "liveG24",
        name: "LiveG24",
        component: Dashboard,
        meta: {title: 'LiveGame - LiveG24'}
      },
      {
        path: "Evolution",
        name: "Evolution",
        component: Evolution,
        meta: {title: 'LiveGame - Evolution'}
      },
      {
        path: "New_Evolution",
        name: "New_Evolution",
        component: New_Evolution,
        meta: {title: 'LiveGame - New Evolution'}
      },
      {
        path: "SA_GAMING",
        name: "SA_GAMING",
        component: SA_Gaming,
        meta: {title: 'LiveGame - SA GAMING'}
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {title: 'LiveGame - login'}
  },
  {
    path: "/maintanence",
    name: "maintanence",
    component: Maintanence,
    meta: {title: 'LiveGame - maintanence'}
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage
  },
  {
    path: "/*",
    component: ErrorPage
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  console.log('path', to, from);
  
  // 设置页面标题
  document.title = to.meta.title || 'LiveGame';

  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = store.state.main.authToken;
    if (!token) {
      // 防止重复导航到 "/login"
      if (to.path !== '/login') {
        return next({
          path: "/login",
          params: { nextUrl: to.fullPath }
        });
      } else {
        return next();
      }
    }
  }

  // 防止已登录用户访问 "/login"
  if (to.name === "login" && store.state.main.authToken) {
    // 防止重复导航到当前路径
    if (from.path !== "/") {
      return next(from.path);
    } else {
      return next({ path: "/" });
    }
  }

  next();
});


export default router;
